import { Card, CardContent } from "@/components/ui/card";
import { Flame, PenLine, Calendar, TrendingUp } from "lucide-react";
import { motion } from "framer-motion";

const JournalStatsCards = ({ stats }) => {
  if (!stats) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 }}
      className="grid grid-cols-2 md:grid-cols-4 gap-4"
    >
      <Card className="glass">
        <CardContent className="py-4 text-center">
          <Flame className="w-6 h-6 text-orange-400 mx-auto mb-2" />
          <p className="text-2xl font-bold text-white">{stats.current_streak}</p>
          <p className="text-mystic-200/70 text-sm">Day Streak</p>
        </CardContent>
      </Card>
      <Card className="glass">
        <CardContent className="py-4 text-center">
          <PenLine className="w-6 h-6 text-mystic-300 mx-auto mb-2" />
          <p className="text-2xl font-bold text-white">{stats.total_entries}</p>
          <p className="text-mystic-200/70 text-sm">Total Entries</p>
        </CardContent>
      </Card>
      <Card className="glass">
        <CardContent className="py-4 text-center">
          <Calendar className="w-6 h-6 text-green-400 mx-auto mb-2" />
          <p className="text-2xl font-bold text-white">{stats.entries_last_30_days}</p>
          <p className="text-mystic-200/70 text-sm">Last 30 Days</p>
        </CardContent>
      </Card>
      <Card className="glass">
        <CardContent className="py-4 text-center">
          <TrendingUp className="w-6 h-6 text-blue-400 mx-auto mb-2" />
          <p className="text-2xl font-bold text-white">
            {stats.mood_distribution?.[0]?.mood || "—"}
          </p>
          <p className="text-mystic-200/70 text-sm">Top Mood</p>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default JournalStatsCards;
